<div
  class="sidenav-top-logo"
  [ngClass]="{ 'sidenav-top-logo-collapsed': collapsed }">
  @if(!collapsed) {
    <a [routerLink]="'/' + routes.DASHBOARD"><mat-icon svgIcon="logo-horizontal" class="w-100 nav-logo" /></a>
    } @if(!isHandset) {
    <mat-icon
      class="sidenav-toggle"
      [ngClass]="{ 'sidenav-toggle-collapsed': collapsed }"
      (click)="clickToggle()"
      >{{ collapsed ? "menu" : "menu_open" }}</mat-icon
      >
    }
  </div>

  @if(inAdminApp() && channels.length > 0) {
    <div>
      <mat-toolbar
        class="loren-sidenav-admin-nav sidenav-mobile-first-item-margin-top mb-4">
        <mat-toolbar-row>
          <mat-form-field class="mt-4 loren-form-field">
            <mat-label>{{ "admin.channel" | transloco }}</mat-label>
            <mat-select
              class="loren-sidenav-select"
              [disabled]="disableChannelSelector$ | async"
              (valueChange)="channelChanged($event)"
              [value]="currentChannel">
              @for(channel of channels; track channel) {
                <mat-option [value]="channel.id">
                  {{ channel.name }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </mat-toolbar-row>
      </mat-toolbar>
    </div>
  }

  <mat-nav-list class="nav-list">
    @for(menuItem of menuItems | async; track menuItem; let isFirst = $first) {
      @if(menuItem.type === menuItemTypes.LINK) {
        <ng-container *lorenFeatureToggle="menuItem.featureToggle">
          @if (
            menuItem.privileges) {
            <ng-container
        *ngTemplateOutlet="
          privilegeBasedLinkTemplate;
          context: { menuItem: menuItem, isFirst: isFirst }
        "></ng-container>
          } @else {
            <ng-container
        *ngTemplateOutlet="
          roleBasedPrivilegedTemplate;
          context: { menuItem: menuItem, isFirst: isFirst }
        "></ng-container>
          }
        </ng-container>
        } @if(menuItem.type === menuItemTypes.SUBHEADER) {
        <ng-container
    *lorenShowForPrivileges="
      menuItem.privileges?.length === 0 ? [] : menuItem.privileges
    ">
          <mat-divider></mat-divider>
          <h3 mat-subheader class="sidenav-subheader">
            {{ menuItem.title | transloco }}
          </h3>
        </ng-container>
        } @if(menuItem.type === menuItemTypes.DIVIDER) {
        <mat-divider></mat-divider>
        } }
      </mat-nav-list>

@if (showPoweredBy) {
    <mat-toolbar
            [ngClass]="{
    'position-absolute bottom-0': !shouldStick,
    'sidenav-toolbar-collapsed': collapsed
  }"
            class="sidenav-toolbar pt-3 pl-3 pr-3">
        <mat-toolbar-row class="sidenav-footer-container">
            <div class="sidenav-footer">
                @if (!collapsed) {
                    <span>powered by</span>
                }
                <mat-icon
                        svgIcon="loren-logo"
                        class="loren-powered-by-logo w-100"></mat-icon>
            </div>
        </mat-toolbar-row>
    </mat-toolbar>
}

      <ng-template
        #privilegeBasedLinkTemplate
        let-menuItem="menuItem"
        let-isFirst="isFirst">
        <a
    *lorenShowForPrivileges="
      menuItem.privileges?.length === 0 ? [] : menuItem.privileges
    "
          mat-list-item
          role="navigation"
          routerLinkActive="active-link"
          class="menu-item"
          [routerLink]="[menuItem.path]"
    [ngClass]="{
      'sidenav-mobile-first-item-margin-top':
        isFirst && !isHandset && !inAdminApp(),
      'menu-item-collapsed': collapsed,
      'menu-item--light': true
    }"
          tourAnchor="{{ menuItem.tourAnchorId }}"
          [matTooltip]="collapsed ? (menuItem.title | transloco) : null"
          (click)="handleClick($event)">
          @if(menuItem.iconType) {
            <mat-icon
              mat-list-icon
              [svgIcon]="menuItem.icon"
              class="{{ menuItem.look + ' loren-sidenav-item-icon' }}">
            </mat-icon>
          } @else {
            <mat-icon
              mat-list-icon
              class="{{ menuItem.look + ' loren-sidenav-item-icon' }}">
              {{ menuItem.icon }}
            </mat-icon>
            } @if(!collapsed) {
            <span class="sidenav-caption">{{ menuItem.title | transloco }}</span>
          }
        </a>
      </ng-template>

      <ng-template
        #roleBasedPrivilegedTemplate
        let-menuItem="menuItem"
        let-isFirst="isFirst">
        <a
          mat-list-item
          *lorenShowForRoles="menuItem.role?.length === 0 ? [] : menuItem.role"
    [ngClass]="{
      'sidenav-mobile-first-item-margin-top':
      isFirst && !isHandset && !inAdminApp(),
      'menu-item-collapsed': collapsed,
    }"
          role="navigation"
          routerLinkActive="active-link"
          class="menu-item"
          tourAnchor="{{ menuItem.tourAnchorId }}"
          [routerLink]="[menuItem.path]"
          (click)="handleClick($event)"
          [matTooltip]="collapsed ? (menuItem.title | transloco) : null">
          @if(menuItem.iconType) {
            <mat-icon
              mat-list-icon
              [svgIcon]="menuItem.icon"
              class="{{ menuItem.look + ' loren-sidenav-item-icon' }}">
            </mat-icon>
          } @else {
            <mat-icon
              mat-list-icon
              class="{{ menuItem.look + ' loren-sidenav-item-icon' }}">
              {{ menuItem.icon }}
            </mat-icon>
            } @if(!collapsed) {
            <span class="sidenav-caption">{{ menuItem.title | transloco }}</span>
          }
        </a>
      </ng-template>
